import { useCallback } from "react";

type Props = {
  text: string;
  fontSize?: number;
  fontStyle?: string;
  fontFamily?: string;
  fontWeight?: string;
};

export function useCanvasTextWidth() {
  return useCallback(
    ({
      text,
      fontSize = 16,
      fontStyle = "normal",
      fontWeight = "normal",
      fontFamily = '"Open Sans", Arial, Helvetica, sans-serif',
    }: Props) => {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      if (!context) {
        return;
      }
      context.font = `${fontStyle} ${fontWeight} ${fontSize}px ${fontFamily}`;
      const measure = context.measureText(text);
      return measure.width;
    },
    []
  );
}
